// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container_20486","total":"NotFound_total_3hAm2","noResult":"NotFound_noResult_2gtsu"};